'use strict';

import '../../js-vendor/spin/spin';
import '../../js-vendor/jquery/jquery.spin';



// WEBPACK FOOTER //
// src/js/aui/spin.js